import { editorLocalization } from 'survey-creator-knockout';

/**
 * Registers translations for custom SurveyJS property grid labels.
 * 
 * @param propertyName - The name of the property registered in Serializer.addProperty
 * @param translations - Key-value map of language codes to display strings
 * @param defaultLang - Optional fallback language key if default locale is missing (defaults to 'de')
 */
export function registerPropertyTranslations(
  propertyName: string,
  translations: Record<string, string>,
  defaultLang: string = 'de'
): void {
  // Register per-language translations
  Object.keys(translations).forEach((lang) => {
    const localeDict = editorLocalization.getLocale(lang);
    if (localeDict) {
      if (!localeDict.p) localeDict.p = {};
      localeDict.p[propertyName] = translations[lang];
    }
  });

  // Fallback for default locale ('')
  const defaultLoc = editorLocalization.getLocale('');
  if (defaultLoc) {
    if (!defaultLoc.p) defaultLoc.p = {};
    defaultLoc.p[propertyName] = translations[defaultLang] || translations['default'] || translations['en'];
  }
}